import _toConsumableArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/* tslint:disable:no-else-after-return */
import localStorage from '@anm/helpers/localStorage';
import { analyticsUrl } from '@anm/hosting-player';
export { analyticsUrl };
var VIEWER_KEY = 'viewerId';
export var analyticsDataUrl = "".concat(analyticsUrl, "player");
export var analyticsCTAUrl = "".concat(analyticsUrl, "cta");
export var analyticsEventUrl = "".concat(analyticsUrl, "event");
export var isDev = process.env.TS_ENV === 'dev';
export var isProd = process.env.TS_ENV === 'prod';
export var generateObjectId = function generateObjectId() {
  var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
    return (Math.random() * 16 | 0).toString(16);
  }).toLowerCase();
}; // export const requestServerTimestamp = () =>
//   axios
//     .get<number>(analyticsUrl + '/timestamp')
//     .then(r => r.data)
//     .catch(() => Date.now());

export var generateViewId = function generateViewId() {
  return generateObjectId();
};
export var setViewer = function setViewer() {
  var viewerId = generateObjectId();
  localStorage().setItem(VIEWER_KEY, viewerId);
  return viewerId;
}; // todo check if localstorage is available, use cookie if not

export var getViewer = function getViewer() {
  return localStorage().getItem(VIEWER_KEY) || setViewer();
};
export var sendData = function sendData(data) {
  return sendDataUrl(analyticsDataUrl)(data);
};
var usePost = true; // todo add retry
// todo add queue and send several events at once

export var sendDataUrl = function sendDataUrl(url) {
  return function (data) {
    var events = Array.isArray(data) ? _toConsumableArray(data) : [data];
    var str = JSON.stringify(events);

    if (usePost) {
      // return navigator.sendBeacon(url, str);
      var request = new XMLHttpRequest();
      request.open('POST', url, true);
      request.setRequestHeader('Content-Type', 'text/plain');

      request.onerror = function (e) {
        return console.log('Error sending analytics', e);
      };

      request.send(str);
      return true;
    } else {
      var img = new Image();
      img.src = "".concat(url, "?data=").concat(btoa(str));

      img.onerror = function (e) {
        return console.log('Error sending analytics', e);
      };

      return true;
    }
  };
};